module.exports = __webpack_public_path__ + "static/media/bg32.7288b0f0.svg";